class GridSwitcher extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.onTriggerClick)
    })
  }

  onTriggerClick (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      triggerEl.setAttribute('aria-pressed', false)
    })

    triggerEl.setAttribute('aria-pressed', true)

    this.setCartAttribute('collection_grid_columns', triggerEl.dataset.columns)
    this.externalEls?.grid?.element.setAttribute(
      'data-columns',
      triggerEl.dataset.columns,
    )
  }

  setCartAttribute (attributeKey, attributeValue) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeKey]: attributeValue,
        },
      }),
    })
  }
}

if (!customElements.get('grid-switcher')) {
  customElements.define('grid-switcher', GridSwitcher)
}
